import React from 'react'
import {Field} from "formik";
import Select from "components/Form/Select";

const styles = {
    textField50: {
        display: 'inline-block', width: '50%'
    }
}

const PresentationForm = ({ element, errors }) => (

    <div>
        <div style={{width:'100%', display:'flex'}}>
            <div style={{...styles.textField50, paddingRight:10}}>

                <Field
                    component={Select}
                    name="number_records"
                    customlabel="Nombre d'antécédents"
                    placeholder='Sélectionner un nombre'
                    options={ [
                        { value : 0, label: 0},
                        { value : 1, label: 1},
                        { value : 2, label: 2},
                        { value : 3, label: 3},
                        { value : 4, label: 4},
                        { value : 5, label: 5},
                        { value : 6, label: 6},
                        { value : 7, label: 7},
                        { value : 8, label: 8},
                        { value : 9, label: 9},
                        { value : 10, label: 10}
                    ]}
                    errors={errors}
                    required
                />

                <Field
                    component={Select}
                    name="take_number_before_display"
                    customlabel="Présenté en prélèvement n°"
                    placeholder='Sélectionner un nombre'
                    options={ [
                        { value : 0, label: "À chaque fois"},
                        { value : 1, label: "1"},
                        { value : 2, label: "2"},
                        { value : 3, label: "3"},
                        { value : 4, label: "4"},
                        { value : 5, label: "5"},
                        { value : 6, label: "6"},
                        { value : 7, label: "7"},
                    ]}
                    errors={errors}
                    required
                />

            </div>
            <div style={{...styles.textField50, paddingLeft:10}}>

                <Field
                    component={Select}
                    name="auto_select_last_record"
                    customlabel="Préselection automatique de la dernière antériorité"
                    placeholder='Sélectionner une valeur'
                    options={ [
                        { value : '', label: "Non"},
                        { value : "yes", label: "Oui"},
                        { value : "yes-today", label: "Oui, du jour"}
                    ]}
                    errors={errors}
                />


            </div>
        </div>


    </div>


)

export default PresentationForm